import { Button } from 'components';
import { saveAs } from 'file-saver';
import { toaster } from 'helpers/toaster';
import { InfoHollowIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { useTransactionsDownload } from 'providers/TransactionsProviders/useTransactionsDownload';
import { useEffect } from 'react';
import { useTransactionsContext } from '../_context/TransactionsContext';

const TRANSACTIONS_HARD_LIMIT = 5000;

const DownloadTransactions = () => {
  const t = useTranslations();

  const { filters, sortAttribute, sortOrder, columnsKeysFiltered, totalPages } =
    useTransactionsContext();

  const { mutateAsync: transactionsDownload, isPending } = useTransactionsDownload();

  const handleTransactionsDownload = () => {
    transactionsDownload({
      filters,
      shownKeys: columnsKeysFiltered,
      sortAttribute,
      sortOrder
    }).then((data) => {
      if (data?.success && data.csvData) {
        const buffer = Buffer.from(data.csvData, 'base64');
        const blob = new Blob([buffer.toString('utf-8')], { type: 'text/csv' });

        return saveAs(blob, 'transactions.csv');
      }

      toaster.error(data?.errors?.at(0));
    });
  };
  const downloadWarning = totalPages > TRANSACTIONS_HARD_LIMIT;

  const disabled = isPending || downloadWarning;

  useEffect(() => {
    if (downloadWarning)
      toaster.warning(
        t('billing.transactions.download_translations.download_error', {
          limit: TRANSACTIONS_HARD_LIMIT
        })
      );
  }, [downloadWarning, t, totalPages]);

  return (
    <Button
      size="small"
      label={t('billing.transactions.download_translations.button')}
      onClick={handleTransactionsDownload}
      className="!m-0 flex !h-[40px] items-center !px-4"
      disabled={disabled}
      colorIcon={disabled ? 'gray-light' : 'white'}
      endAdornment={
        <a
          data-tooltip-id="tolq-info-top-start"
          data-tooltip-html={t.raw('billing.transactions.download_translations.info')}
          className="w-4"
          data-tooltip-offset={10}
        >
          <InfoHollowIcon className="mr-2 origin-[-2px] scale-50 cursor-pointer" />
        </a>
      }
    />
  );
};

export default DownloadTransactions;
